var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-list',{attrs:{"folder-config":_vm.folderConfig,"title":"Авторы","breadcrumbs":_vm.breadcrumbs,"data-source":_vm.dataSource}})
}
var staticRenderFns = []

export { render, staticRenderFns }